





























































import Translations, { LangItem } from "@/services/Translations";

export default {
  name: "HomeAppBar",

  components: {
    // @ts-ignore
    HomeDrawer: () => import("./Drawer"),
  },
  mounted() {},
  methods: {
    selectLanuguage(language: LangItem){
      Translations.setLang(language.code);
    }
  },
  data: () => ({
    drawer: null,
    routes: [
      {
        title: "views.home",
        route: "/",
      },
      {
        title: "views.offer",
        route: "/offer/overview",
      },
      {
        title: "views.projects",
        route: "/projects",
      },
      {
        title: "views.about",
        route: "/about",
      },
      {
        title: "views.contact",
        route: "/contact-us",
      },
    ],
    languages: Translations.getMessages().languages,
  }),
};
